export const SET_PARTNER = 'SET_PARTNER';
